module.exports = __webpack_public_path__ + "img/brbsz.9efac2e9.png";